import componentsRegistry from './components/components'
import Vue from 'vue'
import VueScroller from 'vue-scroller'
import Alert from './plugins/alert'
import Loading from './plugins/loading'
import Request from './plugins/request'
import App from './App'
import router from './router'
import Store from './store'
import WxShare from './utils/share'
import shareImg from './assets/wx-share-v3.png'
import './styles/driver.styl'
Vue.use(Alert)
Vue.use(Loading)
Vue.use(Request)
Vue.use(VueScroller)
componentsRegistry()

// 微信分享
const wxConfig = {
  title: '请来神州当司机',
  pyqTitle: '请来神州当司机，有车无车都能开专车！',
  content: '单均金额80元，工作日天天能提现，速来加入！',
  otherContent: '请来神州当司机，有车无车都能开专车，单均金额80元，速来加入！',
  url: `${location.protocol}//${location.host}/`,
  img: `${
    APP_ENV !== 'test'
      ? location.href.replace(/10101111.+/, '10101111cdn.com')
      : location.href.replace(/10101111.+/, '10101111.com')
  }${shareImg.replace(/[\w/.]+\.com/, '')}`,
}

const shareUtil = new WxShare(wxConfig)
shareUtil.initWeixin()
window.ucarShare = shareUtil

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store: Store,
  router,
  render: h => h(App),
})
const ownAnimationFrame = callback => window.setTimeout(callback, 1000 / 60)

window.requestAnimationFrame = (() =>
  window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.oRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  ownAnimationFrame)()
// 当处于微信环境下时，键盘消失后自动滑动页面主体到键盘出现之前的位置
// const docBody = document.body;
// const docEl = document.documentElement;
// let bodyTop = 0;
// docBody.addEventListener('focusin', event => {
//   bodyTop = docBody.scrollTop || docEl.scrollTop
//   if (event.target) {
//     const { top, y, height } = event.target.getBoundingClientRect()
//     const result = bodyTop + (top || y) - height
//     docBody.scroll(0, bodyTop + (top || y) - height)
//     docEl.scroll(0, result)
//   }
// })
// docBody.addEventListener('focusout', event => {
//   if (/MicroMessenger/i.test(navigator.userAgent)) {
//     docBody.scroll(0, bodyTop)
//     docEl.scroll(0, bodyTop)
//   }
// })
